import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.TREEZOR_DISABLED;

export const useIsTreezorEnabled = () => {
  return !useCompanyFeatureAvailable(featureName);
};
